export default Cidades;

/** @ngInject */
function Cidades(Api) {
  this.buscarCidades = (query) => Api.buscarDados('Cidade', 'buscarCidades', {dsCidade: query});
}



/** WEBPACK FOOTER **
 ** ./common/services/cidades.service.ts
 **/